<template>
	<page>
        <module enable-flex>
            <div class="account flex-wrap">
                <div class="item flex-grow flex-end">
                    <div class="flex-grow">
                        <div class="flex-baseline">
                            <h4>商品名称：</h4>
                            {{questionDetail.product_name}}
                        </div>
                        <div class="flex-baseline">
                            <h4>商品主图：</h4>
                            <product-info :image="questionDetail.product_img_url"></product-info>
                        </div>
                    </div>
                    <div class="flex-grow">
                        <div class="flex-baseline">
                            <h4>问题：</h4><span>{{this.questionDetail.content}}</span>
                        </div>
                        <div class="flex-baseline">
                            <h4>回答总数：</h4><span>{{this.questionDetail.answer_count}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="回答内容">
                    <c-input name="content" placeholder="模糊匹配"></c-input>
                </m-search-item>
                <m-search-item label="状态">
                    <c-select name="state" :options="stateData"></c-select>
                </m-search-item>
                <m-search-item label="用户类型">
                    <c-select name="user_type" :options="userTypeData"></c-select>
                </m-search-item>
                <m-search-item label="回答时间" colspan="2">
                    <c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
                </m-search-item>
            </m-search>

            <m-operate>
				<c-button v-if="auth('b_produc_qa_edit')" color="main" @click="addNewAnswer">发布回答</c-button>
			</m-operate>
			
			<c-table ref="table" height="grow">
				<c-table-column
					type="selector"
				></c-table-column>

				<c-table-column
					label="用户类型"
					width="80"
				>
                    <template #default="{data}">
                        <span v-if="data.user_type == 1">会员</span>
                        <span v-if="data.user_type == 2" style="color:brown">商家</span>
                    </template>
				</c-table-column>

				<c-table-column
					label="回答用户"
					width="200"
				>
                    <template #default="{data}">
                        <product-info v-if="data.user_type == 1" :image="data.head_photo" :name="data.nick_name||'--'"></product-info>
                        <span v-else>{{data.nick_name}}</span>
                    </template>
				</c-table-column>

                <c-table-column
                        label="回答内容"
                        width="300"
                >
                    <template #default="{data}">
                        <span>{{data.content}}</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="状态"
					width="80"
					name="state"
				>
                    <template v-slot="{data}">
                        <c-switch :value="data.state" :state-value="[2,1]" :state-text="['启用','禁用']"
                                  @beforeChange="beforeChangeState(arguments[0], arguments[1], data)"
                        >
                        </c-switch>
                    </template>
				</c-table-column>

				<c-table-column
					label="是否已下单"
					width="80"
					name="is_ordered"
				>
                    <template v-slot="{data}">
                        <span v-if="data.user_type == 1" style="color:green">已下单</span>
                        <span v-else>--</span>
                    </template>
				</c-table-column>

				<c-table-column
					label="点赞数"
					width="80"
					name="thumb_count"
				>
				</c-table-column>

				<c-table-column
					label="回答时间"
					width="150"
				>
					<template v-slot="{data}">
						<p>{{data.create_date}}</p>
					</template>
				</c-table-column>
			</c-table>
		</module>

        <c-dialog ref="answerEdit" title="发布回答" width="600" @resolve="submitAnswer">
            <c-form ref="answerForm">
                <c-form-item label="回答内容" required>
                    <c-input type="textarea" name="content" rows="6" placeholder="请输入回答内容，最多输入500个字符"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from '@/components/public/product_info.vue'
    import {cryptoJs} from "@deanwu/vue-component-library";

	export default {
		components: {
			productInfo
		},
		
		props: {
            questionId: String
		},
		
		data() {
			return {
                questionDetail:{},
                stateData: [
                    {name: '禁用',value: '1'},
                    {name: '启用',value: '2'}
                ],
                userTypeData: [
                    {name: '会员',value: '1'},
                    {name: '商家',value: '2'}
                ]
			}
		},
		
		computed: {
			...mapState(['userInfo','systemConfig'])
		},
		
		mounted() {
            this.getQuestionDetail();

            this.$refs.search.search();
        },

		methods: {
			getQuestionDetail() {
                this.request({
                    url: '/product/question/detail',
                    data: {
                        question_id:this.questionId
                    },
                    loading: true,
                    success: data => {
                         this.questionDetail = data;
                    }
                });
			},
			searchHandle(data) {
                if (this.questionId){
                    data.question_id = this.questionId;
                }
				this.$refs.table.load({
					url: '/product/answer/list',
					data: data
				});
			},
            /***
             * 启用禁用前 回调函数
             */
            beforeChangeState(state,next,data){
                // 确认弹窗
                this.$confirm({
                    title: (state?'禁用':'启用')+'回答',
                    message: '是否确定【'+(state?'禁用':'启用')+'】回答【'+data.content+'】？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product/answer/edit_state',
                            data: {
                                answer_id:data.id,
                                state:state?1:2
                            },
                            loading: true,
                            success: data => {
                                //远程接口调用完成，执行next方法，变更开关状态（执行失败则不变更状态）
                                next();
                                // 消息弹窗
                                this.$message({
                                    message: (state?'禁用':'启用')+'成功',  // 提示内容,
                                    type: 'success'
                                });
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            //新增回答
            addNewAnswer(val) {
                this.$refs.answerForm.clear();
                this.$refs.answerForm.set(val);
                this.$refs.answerEdit.open();
            },
            //提交保存
            submitAnswer(stop) {
                stop();
                this.$refs.answerForm.submit({
                    url: '/product/answer/add',
                    rule: {
                        content: '请填写回答内容',
                    },
                    dataFormatter: data => {
                        data.question_id = this.questionId;
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            message: '回答成功',
                            type: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.answerEdit.close();
                    }
                });
            },
		}
	}
</script>

<style lang="stylus" scoped>
.account {
    padding: 26px 20px;

    .item {
        box-sizing: border-box;
        height: 80px;
        padding: 15px;
        background: #FAF9FC;

        &:nth-child(n+2) {
            margin-left: 25px;
        }

        > div {
            height: 100%;
        }

        label {
            display: block;
            margin: 15px 0 16px;
            font-size: 14px;
            color: #666;
        }

        strong {
            font-size: 30px;
            font-weight: bold;
        }

        span {
            margin-left: 16px;
            font-size: 13px;
            color: #666;
        }
    }
}
</style>